import Api from './api.service'

export default {
  createRole (roleObject) {
    return Api().post('role/create', roleObject)
  },
  updateRole (roleObject) {
    return Api().put('role/edit/' + roleObject.id, roleObject.object)
  },
  getRole (id) {
    return Api().get('role/get/' + id)
  },
  RolesList (filter) {
    return Api().get('role/get', { params: filter })
  },
  routeList () {
    return Api().get('role/routeList')
  }
}